module.exports = __webpack_public_path__ + "static/media/xandz.79a0d1e2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/css/xandz.jpeg
// module id = 28
// module chunks = 0